import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { Menu, X, ArrowUpRight } from "lucide-react";
import { scrollToId } from "@/lib/scroll";

export function Wordmark({ dark = false }) {
  return (
    <Link to="/" className="flex items-center" data-testid="nav-logo">
      <img src="/lima-logo.png" alt="LIMA — Life Inside Media Academy" className="h-9 w-auto" />
    </Link>
  );
}

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const go = (hash) => {
    setOpen(false);
    if (pathname !== "/") {
      navigate("/");
      setTimeout(() => scrollToId(hash), 450);
    } else {
      scrollToId(hash);
    }
  };

  const links = [
    { label: "THE PROGRAM", hash: "#pipeline", testid: "nav-link-program" },
    { label: "HOW YOU LEARN", hash: "#how", testid: "nav-link-how" },
    { label: "PROGRAMS", hash: "#programs", testid: "nav-link-programs" },
    { label: "ABOUT", hash: "#why", testid: "nav-link-about" },
  ];

  return (
    <header className="fixed top-0 left-0 right-0 z-50 border-b border-white/10 bg-black/55 backdrop-blur-xl" data-testid="site-header">
      <div className="flex items-center justify-between h-16 px-5 md:px-10">
        <Wordmark />
        <nav className="hidden lg:flex items-center gap-8">
          {links.map((l) => (
            <button
              key={l.hash}
              data-testid={l.testid}
              onClick={() => go(l.hash)}
              className="font-mono2 text-xs tracking-[0.18em] text-white/70 hover:text-white transition-colors duration-200"
            >
              {l.label}
            </button>
          ))}
          <motion.button
            whileTap={{ scale: 0.96 }}
            data-testid="nav-enquire-button"
            onClick={() => go("#contact")}
            className="font-mono2 text-xs tracking-[0.18em] text-white border-b-2 border-lima-blue pb-1 hover:text-lima-blue transition-colors duration-200 flex items-center gap-2"
          >
            APPLY FOR THE NEXT BATCH <ArrowUpRight size={13} />
          </motion.button>
        </nav>
        <button
          className="lg:hidden text-white"
          onClick={() => setOpen(!open)}
          data-testid="mobile-menu-button"
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>
      {open && (
        <div className="lg:hidden border-t border-white/10 bg-black/90 backdrop-blur-xl px-5 py-6 flex flex-col gap-5" data-testid="mobile-menu">
          {links.map((l) => (
            <button
              key={l.hash}
              data-testid={`mobile-${l.testid}`}
              onClick={() => go(l.hash)}
              className="text-left font-mono2 text-xs tracking-[0.18em] text-white/80"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="mobile-nav-enquire-button"
            onClick={() => go("#contact")}
            className="text-left font-mono2 text-xs tracking-[0.18em] text-lima-blue"
          >
            APPLY FOR THE NEXT BATCH →
          </button>
        </div>
      )}
    </header>
  );
}
